"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, { Component, createContext } from "react";
import { observer } from "mobx-react";
import { action, computed, observable } from "mobx";
import { randomString } from "../../../utils";
import { isNil } from "lodash";
import classNames from "classnames";
const isControlledProps = (props) => !isNil(props.selectedIndex) && !isNil(props.onChange);
const isUncontrolledProps = (props) => !isControlledProps(props);
export const TabsContext = createContext({});
let Tabs = class extends Component {
  constructor(props) {
    var _a;
    super(props);
    this.id = randomString();
    this.tabRefs = [];
    this.setSelectedIndex = (index) => {
      var _a, _b;
      this.prevSelectedIndex = this._selectedIndex;
      this._selectedIndex = index;
      (_b = (_a = this.props).onChange) == null ? void 0 : _b.call(_a, index);
    };
    this.addTabRef = (tabRef, index) => {
      this.tabRefs = [...this.tabRefs.slice(0, index), tabRef, ...this.tabRefs.slice(index)];
    };
    this.removeTabRef = (tabRef) => {
      const newTabRefs = this.tabRefs.filter((ref) => ref !== tabRef);
      this.tabRefs = newTabRefs;
    };
    this.setPanelRef = (panelRef) => {
      this.panelRef = panelRef;
    };
    this.setIndicator = (indicator) => {
      this.indicator = indicator;
    };
    this.updatePanelHeight = (height) => {
      this.panelHeight = height;
    };
    this.focusPanel = () => {
      var _a, _b;
      (_b = (_a = this.panelRef) == null ? void 0 : _a.current) == null ? void 0 : _b.focus();
    };
    if (isControlledProps(props)) {
      this._selectedIndex = props.selectedIndex;
    } else if (isUncontrolledProps(props)) {
      this._selectedIndex = (_a = props.initialIndex) != null ? _a : 0;
    } else {
      this._selectedIndex = 0;
    }
  }
  get selectedIndex() {
    if (isControlledProps(this.props)) {
      return this.props.selectedIndex;
    }
    return this._selectedIndex;
  }
  componentDidUpdate(prevProps) {
    if (isControlledProps(this.props) && !isControlledProps(prevProps)) {
      console.error(
        "Tabs component changed from uncontrolled to controlled component; this may cause unexpected behaviour."
      );
    }
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      TabsContext.Provider,
      {
        value: {
          selectedIndex: this.selectedIndex,
          setSelectedIndex: this.setSelectedIndex,
          prevSelectedIndex: this.prevSelectedIndex,
          tabRefs: this.tabRefs,
          focusPanel: this.focusPanel,
          addTabRef: this.addTabRef,
          removeTabRef: this.removeTabRef,
          setPanelRef: this.setPanelRef,
          panelHeight: this.panelHeight,
          id: this.id,
          updatePanelHeight: this.updatePanelHeight,
          indicator: this.indicator,
          setIndicator: this.setIndicator
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: classNames("tabs", this.props.className) }, this.props.children)
    );
  }
};
__decorateClass([
  observable.ref
], Tabs.prototype, "panelRef", 2);
__decorateClass([
  observable.ref
], Tabs.prototype, "tabRefs", 2);
__decorateClass([
  observable.ref
], Tabs.prototype, "prevSelectedIndex", 2);
__decorateClass([
  observable.ref
], Tabs.prototype, "_selectedIndex", 2);
__decorateClass([
  observable.ref
], Tabs.prototype, "panelHeight", 2);
__decorateClass([
  observable.ref
], Tabs.prototype, "indicator", 2);
__decorateClass([
  action
], Tabs.prototype, "setSelectedIndex", 2);
__decorateClass([
  action
], Tabs.prototype, "addTabRef", 2);
__decorateClass([
  action
], Tabs.prototype, "removeTabRef", 2);
__decorateClass([
  action
], Tabs.prototype, "setPanelRef", 2);
__decorateClass([
  action
], Tabs.prototype, "setIndicator", 2);
__decorateClass([
  action
], Tabs.prototype, "updatePanelHeight", 2);
__decorateClass([
  computed
], Tabs.prototype, "selectedIndex", 1);
Tabs = __decorateClass([
  observer
], Tabs);
export function withTabs(Component2) {
  return function WrapperComponent(props) {
    return /* @__PURE__ */ React.createElement(TabsContext.Consumer, null, (context) => /* @__PURE__ */ React.createElement(Component2, __spreadProps(__spreadValues({}, props), { tabs: context })));
  };
}
export default Tabs;
